import {
  ErrorViewState,
  openSearch,
} from '@squareup/dex-data-shared-main-data-slices';
import { useSharedDispatch } from '@squareup/dex-store-access-shared-main-dispatch';
import { ChildrenProp } from '@squareup/dex-types-shared-ui';
import { getStateNodeErrorStatusAndMessage } from '@squareup/dex-utils-error';
import React, { FC } from 'react';

import { PageErrorContents } from './PageErrorContents';

interface PageErrorHandlerProps {
  error: ErrorViewState;
  /**
   * The href to the return the user to when this want to retry
   */
  returnHref: string;
}

const PageErrorHandler: FC<PageErrorHandlerProps & ChildrenProp> = ({
  error,
  children,
  returnHref,
}) => {
  const dispatch = useSharedDispatch();

  const errorStatusAndMessage = getStateNodeErrorStatusAndMessage(
    error.global || error.page
  );
  const isGlobal = error.global;

  if (errorStatusAndMessage) {
    const errorType =
      errorStatusAndMessage.statusCode === 404 ? 'not-found' : 'unhandled';

    return (
      <PageErrorContents
        errorType={errorType}
        errorMessage={errorStatusAndMessage.message}
        showSearchButton={!isGlobal && errorType !== 'unhandled'}
        onSearchClicked={() => dispatch(openSearch())}
        returnHref={returnHref}
      />
    );
  } else {
    return <>{children}</>;
  }
};

export { PageErrorHandler };
